export default "__VITE_ASSET__Bb4UQeCN__"